import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import BackToTop from "@/components/feature/BackToTop";
import JsonLd from "@/components/feature/JsonLd";
import PageSeo from "@/components/feature/PageSeo";
import Hero from "./components/Hero";
import FlashTicker from "./components/FlashTicker";
import FeaturedSection from "./components/FeaturedSection";
import CategoryGrid from "./components/CategoryGrid";
import LatestFeed from "./components/LatestFeed";
import RankingSection from "./components/RankingSection";
import TestimonialSection from "./components/TestimonialSection";
import FaqSection from "./components/FaqSection";
import { faqs, gossipItems, siteInfo } from "@/mocks/gossip";

export default function Home() {
  const organizationLd = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: siteInfo.brand,
    url: "https://hebeishifenhao.cn/",
    description: siteInfo.intro,
    email: siteInfo.email,
  };

  const websiteLd = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: siteInfo.brand,
    url: "https://hebeishifenhao.cn/",
    inLanguage: "zh-CN",
    potentialAction: {
      "@type": "SearchAction",
      target: "https://hebeishifenhao.cn/category?q={search_term_string}",
      "query-input": "required name=search_term_string",
    },
  };

  const faqLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((item) => ({
      "@type": "Question",
      name: item.q,
      acceptedAnswer: { "@type": "Answer", text: item.a },
    })),
  };

  const listLd = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    name: "热门瓜料推荐",
    itemListElement: gossipItems.slice(0, 6).map((item, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: item.title,
      url: `https://hebeishifenhao.cn/article/${item.id}`,
    })),
  };

  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <PageSeo
        title="瓜田前线 - 网曝吃瓜视频图片截图实拍画面合集"
        description="瓜田前线聚合网曝吃瓜视频、吃瓜图片、聊天截图与实拍现场画面，覆盖娱乐爆料、网红动态、影视综艺与电竞热点，热瓜榜单持续更新。"
        keywords="网曝吃瓜,吃瓜视频,吃瓜图片,吃瓜截图,流出画面,实拍现场"
        canonical="https://hebeishifenhao.cn/"
      />
      <JsonLd data={organizationLd} />
      <JsonLd data={websiteLd} />
      <JsonLd data={faqLd} />
      <JsonLd data={listLd} />

      <Navbar />
      <main className="flex-1 w-full">
        <Hero />
        <FlashTicker />
        <FeaturedSection />
        <CategoryGrid />
        <LatestFeed />
        <RankingSection />
        <TestimonialSection />
        <FaqSection />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}